/**
 * Google Analytics 4 — eventos de conversão (SEO-002/003, 05/10/2026).
 *
 * O gtag só é carregado pelo index.html quando REACT_APP_GA4_ID está
 * definido E o site roda no domínio toalugando.com.br — mesma guarda do Meta
 * Pixel: o index.html vai empacotado no app Android/iOS, e a declaração de
 * Data Safety do Google Play nega finalidade publicitária. A checagem de
 * hostname se repete aqui pelo mesmo motivo do lib/pixel.js.
 *
 * page_view: automático (medição otimizada do GA4 conta trocas de URL do
 * History API — o app usa pushState em toda navegação).
 *
 * Os eventos chegam pelo `track()` do lib/pixel.js: cada conversão que já
 * ia pra Meta vai também pro GA4, com o nome de evento recomendado do Google.
 */

const DOMINIO = 'toalugando.com.br';

// Evento da Meta → evento recomendado do GA4
export const EVENTOS_GA4 = {
  CompleteRegistration: 'sign_up',   // cadastro
  ViewContent: 'view_item',          // visualização de anúncio
  InitiateCheckout: 'begin_checkout', // início de locação
  Purchase: 'purchase',              // locação paga (confirmada)
  Search: 'search',
};

const ativo = () =>
  typeof window !== 'undefined' &&
  window.location.hostname.indexOf(DOMINIO) !== -1 &&
  typeof window.gtag === 'function';

/** Parâmetros no formato do GA4 a partir do payload que já vai pra Meta. */
export function paramsGa4(nome, dados = {}) {
  const p = {};
  if (dados.currency) p.currency = dados.currency;
  if (typeof dados.value === 'number') p.value = dados.value;
  const ids = Array.isArray(dados.content_ids) ? dados.content_ids : [];
  if (ids.length) {
    p.items = ids.map((id) => ({ item_id: String(id), ...(dados.content_name ? { item_name: dados.content_name } : {}) }));
  }
  if (nome === 'purchase' && dados.order_id) p.transaction_id = String(dados.order_id);
  if (nome === 'sign_up') p.method = dados.content_name === 'cadastro_google' ? 'google' : 'email';
  if (nome === 'search' && dados.search_string) p.search_term = String(dados.search_string);
  return p;
}

export function eventoGa4DaMeta(evento, dados = {}) {
  const nome = EVENTOS_GA4[evento];
  if (!nome || !ativo()) return;
  try {
    window.gtag('event', nome, paramsGa4(nome, dados));
  } catch { /* analytics nunca derruba o app */ }
}

/**
 * Funil do site (pedido do dono, 08/10/2026): passos que a Meta não recebe e
 * o GA4 precisa para o relatório de funil — add_to_cart, view_cart e
 * pedido_enviado (pedido mandado ao locador, antes da aprovação). Mesma guarda
 * de domínio; nunca lança.
 */
export function eventoGa4(nome, params = {}) {
  if (!ativo()) return;
  try {
    window.gtag('event', nome, params);
  } catch { /* analytics nunca derruba o app */ }
}

/** Linha do carrinho/pedido no formato `items` do GA4. */
export function itemGa4(it = {}) {
  const id = it.equipamento_id || it.id;
  const out = { item_id: String(id ?? '') };
  const nome = it.nome || it.nome_equipamento;
  if (nome) out.item_name = String(nome);
  const cat = it.cat || it.categoria;
  if (cat) out.item_category = String(cat);
  const qtd = Number(it.quantidade) || 1;
  out.quantity = qtd;
  const valor = Number(it.subtotal ?? it.valor_total ?? it.preco);
  if (Number.isFinite(valor) && valor > 0) out.price = Number((valor / qtd).toFixed(2));
  return out;
}
